import React from 'react';
import { Helmet } from 'react-helmet';

const ContactDetails = () => {
  return (





<div>

    

<section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">Contact Us </h1>
          </div>
        </div>
      </section>



    <section className="contact-details py-5" >
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="contact-details__right">
              <div className="sec-title">
                <span className="sub-title text-white fw-bold fs-4 darkcolor">Need any help ?</span>
                <h2 className='text-white p-0 darkcolor'>Get in touch with us</h2>
               
              </div>
              <div className="row pt-0 "style={{backgroundColor:'#0310A8'}}>
                <div className="col-md-4 text-center p-3  border">
                  <div className="contact-item align-items-center">
                    <div className="icon">
                      <span className="lnr-icon-phone-plus p-3 bg-darkkk text-white"></span>
                    </div>
                    <div className="text ml-xs--0 mt-xs-10 pt-3 ">
                      <h4 className='text-white'>Have any question ?</h4>
                      <a href="tel:+919594917913" className='text-white'>+91 9594917913</a><br/>
                    </div>
                  </div>
                </div>
                <div className="col-md-4  text-center p-3 border">
                  <div className="contact-item  align-items-start">
                    <div className="icon text-center">
                      <span className="lnr-icon-envelope1 p-3 bg-darkkk text-white"></span>
                    </div>
                    <div className="text ml-xs--0 mt-xs-10 pt-3">
                      <h4 className='text-white'>Write email</h4>
                      <a href="mailto:booking@shreecabs24.com" className='text-white'><span>booking@shreecabs24.com
                      </span></a>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 text-center p-3 border">
                  <div className="contact-item align-items-center">
                    <div className="icon">
                      <span className="lnr-icon-location p-3 bg-darkkk text-white" ></span>
                    </div>
                    <div className="text ml-xs--0 mt-xs-10 pt-3 text-white">
                      <h4 className='text-white'>SHREE Tours & Travels</h4>
                      Maharashtra Co-Operative Housing Society,
                      Yerawada, Pune, Maharashtra India - 411006

                      </div>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </section>

<section className="map-section">




<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2989.372022951472!2d73.8973522!3d18.561875399999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c1470c781897%3A0xb25dd8d5491ad17!2sShree%20Tours%20And%20Travels!5e1!3m2!1sen!2sin!4v1742625980644!5m2!1sen!2sin" width="100%" height="500" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>






</section>
</div>

  );
};

export default ContactDetails;
